import { ListDefault } from './Entities/ListDefault.js';
import { Administrator } from './Entities/Administrator.js';
import { Attraction } from './Entities/Attraction.js';
import { Characters } from './Entities/Characters.js';
import { Experiment } from './Entities/Experiment.js';
import { History } from './Entities/History.js';
import { Origin } from './Entities/Origin.js';
import { Outlinks } from './Entities/Outlinks.js';
import { User } from './Entities/User.js';
import StitchNope from '../../../assets/images/others/gif/stitch-nope.gif';

export const Entities = (props) => {
    const { entity, datas } = props;
    if (datas && datas.length > 0) {
        switch (entity) {
            case 'administrator': return (<Administrator entity={entity} datas={datas} />);
            case 'attraction': return (<Attraction entity={entity} datas={datas} />);
            case 'user': return (<User entity={entity} datas={datas} />);
            case 'characters': return (<Characters entity={entity} datas={datas} />);
            case 'experiment': return (<Experiment entity={entity} datas={datas} />);
            case 'history': return (<History entity={entity} datas={datas} />);
            case 'outlinks': return (<Outlinks entity={entity} datas={datas} />);
            case 'origin': return (<Origin entity={entity} datas={datas} />);
            case 'category':
            case 'park':
            case 'univers': return (<ListDefault entity={entity} datas={datas} />);
            default: return (<></>);
        }
    } else {
        return (
            <section className="quatre-cent-quatre">
                <div className="stitch">
                    <img src={StitchNope} alt="stitch-nope" title="stitch-nope" />
                </div>
                <div className="not">SORRY</div>
                <div className="found">Your page is not found on this server</div>
            </section>
        );
    }
}
